import React, { ReactElement } from 'react';
import { Modal, Paragraph, SignOutIcon } from 'elmo-elements';
import { useDispatch, useSelector } from 'react-redux';
import {
  actions as ElearningPlayerActions,
  ElearningPlayerStateType,
} from '@/components/Player/modules/reducers/elearningPlayer';

const QuizHelper = (): ReactElement => {
  const dispatch = useDispatch();

  const closeQuizHelperHandler = () => {
    dispatch({
      type: ElearningPlayerActions.closeQuizHelper.type,
    });
  };
  const elearningPlayerState: ElearningPlayerStateType = useSelector(
    (state: { elearningPlayer: ElearningPlayerStateType }) =>
      state.elearningPlayer,
  );

  return (
    <Modal
      id="ModalDialog"
      type="large"
      isOpened={elearningPlayerState.isVisibleQuizHelper}
      closeModal={closeQuizHelperHandler}
      title="Assessment Help"
      closeLabel="Close"
      hasCloseFooterButton={false}
    >
      <Paragraph className="text-left">
        After reading the questions, select answer <b>A</b>, <b>B</b>, <b>C</b>{' '}
        or <b>D</b> by clicking or touching the corresponding button.
      </Paragraph>
      <hr />
      <Paragraph className="text-left">
        Once your answer is selected, use the 'Click to continue' button in the
        bottom right to move onto the next part of your assessment.
      </Paragraph>
      <hr />
      <Paragraph className="text-left">
        To exit the assessment, click or touch the
        <SignOutIcon /> icon. This will trigger a cancellation prompt. Selecting
        YES will cancel the assessment and return you to the module.
      </Paragraph>
      <hr />
      <Paragraph className="text-left">
        Once you have completed all the questions in the assessment, you will be
        notified as to whether you have passed or failed. You can then submit
        your results or retry the assessment based on the outcome.
      </Paragraph>
    </Modal>
  );
};

export default QuizHelper;
